import { useQuery } from "react-query"
import { AxiosResponse } from "axios"

import { IGetLaundryDistrictsRes } from "types/laundry"

import laundriesService from "api/laundriesService"

const useGetLaundryDistricts = (enabled: boolean) => {
  return useQuery("laundry_districts", async () => {
    try {
      const res: AxiosResponse<IGetLaundryDistrictsRes> = await laundriesService.getLaundryDistricts()

      return res.data
    }  catch (err: any) {
      return err.response
    }
  }, { enabled, refetchOnWindowFocus: false })
}

export default useGetLaundryDistricts